import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api/admin`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminData');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const loginAdmin = (email, password) => 
  api.post('/login', { email, password });

export const getAdminProfile = () => 
  api.get('/profile');

// Dashboard
export const getDashboardStats = () => 
  api.get('/dashboard/stats');

// Users
export const getUsers = () => 
  api.get('/users');

export const getUser = (id) => 
  api.get(`/users/${id}`);

// Properties
export const getProperties = () => 
  api.get('/properties');

export const getProperty = (id) => 
  api.get(`/properties/${id}`);

// Bookings
export const getBookings = (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  return api.get(`/bookings?${params}`);
};

// Reviews
export const getReviews = () => 
  api.get('/reviews');

// Notifications
export const getNotifications = () => 
  api.get('/notifications');

// Analytics
export const getAnalytics = () => 
  api.get('/analytics');

// Audit Logs
export const getAuditLogs = () => 
  api.get('/audit-logs');

// Settings
export const getSettings = () => 
  api.get('/settings');

export default api;
